"use client";

import { routes } from "../../../../config/routes";
import AvatarCard from "@core/ui/avatar-card";
import DateCell from "@core/ui/date-cell";
import { createColumnHelper } from "@tanstack/react-table";
import { Text, Flex } from "rizzui";
// import TableRowActionGroup from "../../table-row-action-group";
import { Campaign } from "packages/app/src/types";
import { MoreActions } from "../../../../components/table-utils/campaign-more-actions";
import { suspendCampaign } from "../../../api/suspend-campaign";

function formatCurrency(amount: number, code: string) {
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: code,
      minimumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
    })} ${code}`;
  }
}

const columnHelper = createColumnHelper<any>();

export const campaignListColumns = [

  columnHelper.accessor("_id", {
    header: "Payment ID",
    size: 200,
    cell: (info) => (
      <Text className="text-sm font-medium">{info.getValue()}</Text>
    ),
  }),
  columnHelper.accessor("transactionId", {
    header: "Transaction ID",
    size: 200,
    cell: (info) => (
      <Text className="text-sm font-medium">{info.getValue()}</Text>
    ),
  }),
  columnHelper.accessor("productId", {
    header: "Product ID",
    size: 200,
    cell: (info) => (
      <Text className="text-sm font-medium">{info.getValue()}</Text>
    ),
  }),


  columnHelper.accessor("payerEmail", {
    header: "Payer Email",
    size: 160,
    enableSorting: true,
    cell: (info) => (
      <Text className="text-sm font-medium">{info.getValue()}</Text>
    ),
  }),
  columnHelper.accessor("payerFirstName", {
    header: "Payer First Name",
    size: 160,
    enableSorting: true,
    cell: (info) => {

      if (info.getValue() === null || info.getValue() === undefined) {
        return (
          <Text className="text-sm text-center font-medium text-gray-400">
            -
          </Text>
        );
      }
      return (
        <Text className="text-sm capitalize font-medium">{info.getValue()}</Text>
      )
    },
  }),
  columnHelper.accessor("payerLastName", {
    header: "Payer Last Name",
    size: 160,
    enableSorting: true,
    cell: (info) => {

      if (info.getValue() === null || info.getValue() === undefined) {
        return (
          <Text className="text-sm text-center font-medium text-gray-400">
            -
          </Text>
        );
      }
      return (
        <Text className="text-sm capitalize font-medium">{info.getValue()}</Text>
      )
    },
  }),
  columnHelper.accessor("paymentMethod", {
    header: "Payment Method",
    size: 160,
    enableSorting: true,
    cell: (info) => {

      if (info.getValue() === null || info.getValue() === undefined) {
        return (
          <Text className="text-sm text-center font-medium text-gray-400">
            -
          </Text>
        );
      }
      return (
        <Text className="text-sm capitalize font-medium">{info.getValue()}</Text>
      )
    },
  }),
  columnHelper.accessor("amount", {
    header: "Amount",
    size: 160,
    enableSorting: true,
    cell: (info) => {
      const amount = info.getValue();
      const curr = info.row.original.currencyUsed || "NGN";
      return (
        <Text className="text-sm font-medium text-green-600">
          {formatCurrency(amount, curr)}
        </Text>
      );
    },
  }),
  columnHelper.accessor("status", {
    header: "Status",
    size: 160,
    enableSorting: true,
    cell: (info) => (
      <Text className="text-sm  font-medium">{info.getValue()}</Text>
    ),
  }),


  columnHelper.accessor("createdAt", {
    header: "Created On",
    size: 200,
    cell: (info) => <DateCell date={new Date(info.getValue())} />,
  }),

];